/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Xl8SubtitleType {
    JSON = 'json',
    PAC = 'pac',
    SCC = 'scc',
    SRT = 'srt',
    DFXP = 'dfxp',
    TTML = 'ttml',
    IMSC = 'imsc',
    ITT = 'itt',
    VTT = 'vtt',
    XIF = 'xif',
    STL = 'stl',
    SMI = 'smi',
    XLSX = 'xlsx',
    TXT = 'txt',
    DOCX = 'docx',
}
